import classNames from "classnames";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
interface IRatingCardProps {
  feedbackOverallRatingScore?: number;
  feedbackReviewCount: number;
}
export const RatingCard = ({
  feedbackReviewCount,
  feedbackOverallRatingScore,
}: IRatingCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["raiting_card_container"]}>
      <img alt="img" src="/assets/images/svg/starRatingFill.svg" />

      <p className={classNames(styles["h3"])}>
        {" "}
        {feedbackOverallRatingScore?.toFixed(2)}{" "}
      </p>

      <p className={styles["p2"]}>
        {" "}
        {t("lbl_reviews_rates_list", {
          length: feedbackReviewCount,
        })}{" "}
      </p>
    </div>
  );
};
